<template>
  <div class="preview-container flex gap-2">
    <!-- Selected Brand -->
    <div class="selected-brand flex-shrink-0 flex items-center justify-center">
      <img src="https://publicassets.foreplay.co/create-lens-preview-brands/dunder-mifflin.png" class="w-7 h-7" style="border-radius: 4px;">
    </div>
    <!-- Brand Search Preview -->
    <div class="flex-grow h-full flex flex-col gap-1 p-1 rounded-lg bg-neutral-25">
      <!-- Search Bar -->
      <div class="w-full flex items-center gap-2 p-1.5">
        <SearchIcon className="text-text-subdued" />
        <BaseText type="body" size="sm" class="text-text-subdued whitespace-nowrap">
          Search Lens Brands...
        </BaseText>
      </div>
      <!-- Brand Items -->
      <div v-for="(brand, index) in brandPreviews" :key="`${brand.key}-preview`"
      class="flex items-center gap-2 p-1.5 rounded-md" :class="{'selected-item': index === 0}">
        <img 
          :src="brand.logo" 
          class="brand-logo w-5 h-5 flex-shrink-0" 
          style="border-radius: 4px;"
          @load="(e) => { e.target.style.opacity = 1 }"
        >
        <BaseText type="body" size="sm" class="text-text-muted">
          {{ brand.name }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import SearchIcon from '../../../globals/Icons/SearchIcon.vue'

export default {
  name: 'LensBrandModalPreview',
  components: {
    SearchIcon
  },
  data () {
    return {
      brandPreviews: [
        {
          name: 'Dunder Mifflin',
          key: 'dunder-mifflin',
          logo: 'https://publicassets.foreplay.co/create-lens-preview-brands/dunder-mifflin.png'
        },
        {
          name: 'Pied Piper',
          key: 'pied-piper',
          logo: 'https://publicassets.foreplay.co/create-lens-preview-brands/pied-piper.png'
        },
        {
          name: 'Initech',
          key: 'initech',
          logo: 'https://publicassets.foreplay.co/create-lens-preview-brands/initech.png'
        },
        {
          name: 'Hooli',
          key: 'hooli',
          logo: 'https://publicassets.foreplay.co/create-lens-preview-brands/hooli.png'
        }
      ]
    }
  }
}
</script>

<style scoped>
.preview-container {
  position: absolute;
  top: 28px;
  left: 28px;
  width: 232px;
  height: 208px;
}
.selected-brand {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #EAEFF3;
}
.selected-item {
  background-color: white;
  box-shadow: 0 36px 48px -12px rgba(53, 57, 75, 0.20), 0 24px 32px -12px rgba(53, 57, 75, 0.24), 0 1px 2px 0 rgba(162, 172, 186, 0.16);
}
.brand-logo {
  opacity: 0;
  transition: opacity 100ms ease-in-out;
}
</style>